<template>
  <button
    aria-controls="navbar-default"
    :aria-expanded="isOpen"
    :aria-label="isOpen ? t('sofax.nav.closeMenu') : t('sofax.nav.openMenu')"
    class="inline-flex size-11 items-center justify-center rounded-full text-ink transition-all duration-300 hover:bg-surface focus:outline-none focus-visible:ring-2 focus-visible:ring-accent dark:text-white dark:hover:bg-gray-800"
    type="button"
    @click="toggleMenu"
  >
    <!-- The template's three-bar trigger: bars collapse into a cross when open -->
    <span class="relative flex h-4 w-6 flex-col justify-between" aria-hidden="true">
      <span
        class="block h-0.5 w-full rounded-full bg-current transition-all duration-300"
        :class="{ 'translate-y-[7px] rotate-45': isOpen }"
      />
      <span
        class="block h-0.5 w-full rounded-full bg-current transition-all duration-300"
        :class="{ 'opacity-0': isOpen }"
      />
      <span
        class="block h-0.5 w-full rounded-full bg-current transition-all duration-300"
        :class="{ '-translate-y-[7px] -rotate-45': isOpen }"
      />
    </span>
  </button>
</template>

<script setup lang="ts">
const { t } = useI18n()

const props = defineProps({
  isOpen: {
    type: Boolean,
    required: true,
  },
});

const emit = defineEmits(['update:isOpen']);

function toggleMenu() {
  emit('update:isOpen', !props.isOpen);
}
</script>
